export const COMPONENT_NAME = "shared-card";
